var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bccd30;}.cls-2{fill:#f8991d;}.cls-3{fill:#f8db94;}.cls-4{fill:#314967;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "05 Wallet",
    id: "_05_Wallet"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.14,30.55a4,4,0,0,0-4.81-3L86,29.51,82.3,22a4,4,0,0,0-5.36-1.81L37,40h64.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 72,
    rx: 6,
    ry: 6,
    width: 90,
    x: 19,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    height: 28,
    rx: 4,
    ry: 4,
    width: 36,
    x: 76,
    y: 62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.46,33.8l18.33-4.28A2,2,0,0,1,97.19,31l.86,3.7a2,2,0,0,0,3.89-.91l-.86-3.7a6,6,0,0,0-7.21-4.48L75.54,29.9A2,2,0,0,0,76.46,33.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21,86.43V46a4,4,0,0,1,4-4H84.15a2,2,0,0,0,0-4H58.47l12.41-2.9A2,2,0,0,0,70,31.2L49.66,35.95,77.83,22a2,2,0,0,1,2.68.9l1,2.05a2,2,0,0,0,3.59-1.77l-1-2.06a6,6,0,0,0-8-2.72L36.5,38H25a8,8,0,0,0-8,8V86.43A2,2,0,0,0,21,86.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.79,110H25a4,4,0,0,1-4-4V94.3a2,2,0,0,0-4,0V106a8,8,0,0,0,8,8H82.79A2,2,0,0,0,82.79,110Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107,95.87V106a4,4,0,0,1-4,4H89.42a2,2,0,0,0,0,4H103a8,8,0,0,0,8-8V95.87A2,2,0,0,0,107,95.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111,60.81V46a8,8,0,0,0-8-8H91.55a2,2,0,0,0,0,4H103a4,4,0,0,1,4,4V60H80a6,6,0,0,0-6,6,2,2,0,0,0,4,0,2,2,0,0,1,2-2h28a2,2,0,0,1,2,2V76a2,2,0,0,0,4,0V66A6,6,0,0,0,111,60.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110,82v4a2,2,0,0,1-2,2H80a2,2,0,0,1-2-2V73.12a2,2,0,0,0-4,0V86a6,6,0,0,0,6,6h28a6,6,0,0,0,6-6V82A2,2,0,0,0,110,82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 88.55,
    cy: 76,
    r: 5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatOrders);
export default __webpack_public_path__ + "static/media/stat_orders.471a0c79d3bf03a29aba24bddead4464.svg";
export { ForwardRef as ReactComponent };